import { createNumberWithDisplayValue } from 'Pages/vehicles/helpers/createNumberWithDisplayValue';
import { resolveHasOtherContactActiveBid, resolveUserBids } from 'Utilities/mappers';

import type {
	MapOwnBids,
	MapOwnBidsParams,
	MapRealtimeBiddingDataToVehicleBiddingData,
	MapRealtimeBiddingDataToVehicleBiddingDataParams,
} from './mapRealtimeBiddingDataToVehicleBiddingData.types';

const mapOwnBids = ({ ownBids, user }: MapOwnBidsParams): MapOwnBids => {
	const usersLatestBid = resolveUserBids(ownBids, user)[0];

	const mappedLatestUserBidOrOffer = usersLatestBid
		? {
				bidOrOfferAmount: createNumberWithDisplayValue(usersLatestBid.value),
				bidOrOfferId: usersLatestBid.id,
		  }
		: null;

	return {
		hasOtherContactActiveBid: resolveHasOtherContactActiveBid(ownBids, user),
		latestUserBidOrOffer: mappedLatestUserBidOrOffer,
		legacyBids: {
			usersBids: ownBids,
		},
	};
};

export const mapRealtimeBiddingDataToVehicleBiddingData = ({
	realtimeBiddingData,
	user,
}: MapRealtimeBiddingDataToVehicleBiddingDataParams): MapRealtimeBiddingDataToVehicleBiddingData => {
	const priceReserve = realtimeBiddingData.sellerWillAcceptPrice
		? { priceReserve: createNumberWithDisplayValue(realtimeBiddingData.sellerWillAcceptPrice) }
		: null;

	const displayPrice = realtimeBiddingData.acceptedBid
		? { displayPrice: createNumberWithDisplayValue(realtimeBiddingData.acceptedBid.value) }
		: null;

	const minimumBid = realtimeBiddingData.minimumBid ? { minimumBid: realtimeBiddingData.minimumBid } : null;
	const soldDate = realtimeBiddingData.soldDate ? { soldDate: realtimeBiddingData.soldDate } : null;
	const highestBid = realtimeBiddingData.highestBid
		? { highestBidOrOffer: createNumberWithDisplayValue(realtimeBiddingData.highestBid.value) }
		: null;

	return {
		...displayPrice,
		...minimumBid,
		...soldDate,
		...priceReserve,
		...highestBid,
		...mapOwnBids({ ownBids: realtimeBiddingData.ownBids, user }),
	};
};
